export const lead = {
  name: '',
  cnpj: null,
  city: null,
  email: '',
  responsible: '',
  state: null,
  phone: null,
  country: 'Brasil',
  zipcode: null,
  product_interest: [],
  kit_quantity: null,
  kit_condition: null,
  contact_by: [],
  segment: [],
  companyType: null,
  companyAge: null,
  monthlyRevenueAverage: null,
  buy_from: null,
};
